import axiosInstance from "../axiosInstance";

export const mapApi = resort_id => {
  return axiosInstance.get(`/api/resorts/${resort_id}`);
};
